export namespace NLoginFormModal {
    export interface IModalData {
        email?: string;
        variant?: EModalVariant;
    }

    export enum EModalVariant {
        close = 'close'
    }

    export const LOGIN_FORM_MODAL_ID = 'login-form-modal';
}
